// extracted by mini-css-extract-plugin
export default {"advertCardHeader":"c-a_iw","advertCardHeader__actions":"c-a_ix","advertCardHeader__bottomLabel":"c-a_iy"};